import { render } from "./SidenavItem.vue?vue&type=template&id=616f92ed"
import script from "./SidenavItem.vue?vue&type=script&lang=js"
export * from "./SidenavItem.vue?vue&type=script&lang=js"

import "./SidenavItem.vue?vue&type=style&index=0&id=616f92ed&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__